import { render, staticRenderFns } from "./AppMacroBtn.vue?vue&type=template&id=4be9dbf8&scoped=true&"
import script from "./AppMacroBtn.vue?vue&type=script&lang=ts&"
export * from "./AppMacroBtn.vue?vue&type=script&lang=ts&"
import style0 from "./AppMacroBtn.vue?vue&type=style&index=0&id=4be9dbf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be9dbf8",
  null
  
)

export default component.exports